import React from "react"

export default function Terms() {
  return (
    <>
      <section>
        <div className="overlay flex items-center justify-center text-center"></div>
      </section>

      <div className="privacy__policy pt-20 md:pt-40 pb-10 px-5 text-gray-800 bg-gray-50 2xl:px-0">
        <article className="xl:max-w-5xl xl:mx-auto">
          <h1>Terms and Conditions</h1>
          <p>
            Welcome to Be Brokers. If you continue to browse and use this
            website you are agreeing to comply with and be bound by the
            following terms and conditions of use, which together with our
            privacy policy govern Be Brokers’s relationship with you in relation
            to this website. Each time you use the website, the current version
            of the Terms and Conditions will apply. Accordingly, when you use
            the website, you should check the date of the Terms and Conditions
            (which appears at the bottom) and review any changes since the last
            version.
          </p>
          <p>
            Please review carefully the entire website Terms and Conditions
            before agreeing to them. By viewing or using this website or any
            part of it, you agree to all of the Terms and Conditions of this
            website.
          </p>
          <p>
            The term Be Brokers or "us" or "we" refers to the owner of the
            website whose. The term "you" refers to the user or viewer of our
            website. The use of this website is subject to the following terms
            of use:
          </p>
          All performance claims found on Be Brokers about trading systems or
          strategies must be regarded as hypothetical. Use of Be Brokers to
          offer or subscribe to a trading system or strategy indicates you agree
          to our Terms & Conditions. Before using any systems or strategies
          listed on Be Brokers you should be aware that there is often a vast
          difference between hypothetical results, and real-life trading results
          achievable in a real brokerage account, and real-live results are
          almost always vastly worse than hypothetical results.
          <h4>Performance</h4>
          <p>
            Results for systems and strategies listed on Be Brokers do not take
            into account fees, spreads and/or trading commissions that may be
            charged by your broker or a money manager. Please consult with your
            broker for information on these costs. Additional information on how
            Be Brokers calculates performance data can be found on the Be
            Brokers help page.
          </p>
          <p>
            HYPOTHETICAL PERFORMANCE RESULTS HAVE MANY INHERENT LIMITATIONS,
            SOME OF WHICH ARE DESCRIBED BELOW. NO REPRESENTATION IS BEING MADE
            THAT ANY ACCOUNT WILL OR IS LIKELY TO ACHIEVE PROFITS OR LOSSES
            SIMILAR TO THOSE SHOWN. IN FACT, THERE ARE FREQUENTLY SHARP
            DIFFERENCES BETWEEN HYPOTHETICAL PERFORMANCE RESULTS AND THE ACTUAL
            RESULTS SUBSEQUENTLY ACHIEVED BY ANY PARTICULAR TRADING PROGRAM. ONE
            OF THE LIMITATIONS OF HYPOTHETICAL PERFORMANCE RESULTS IS THAT THEY
            ARE GENERALLY PREPARED WITH THE BENEFIT OF HINDSIGHT. IN ADDITION,
            HYPOTHETICAL TRADING DOES NOT INVOLVE FINANCIAL RISK, AND NO
            HYPOTHETICAL TRADING RECORD CAN COMPLETELY ACCOUNT FOR THE IMPACT OF
            FINANCIAL RISK IN ACTUAL TRADING. FOR EXAMPLE, THE ABILITY TO
            WITHSTAND LOSSES OR ADHERE TO A PARTICULAR TRADING PROGRAM IN SPITE
            OF TRADING LOSSES ARE MATERIAL POINTS WHICH CAN ALSO ADVERSELY
            AFFECT ACTUAL TRADING RESULTS. THERE ARE NUMEROUS OTHER FACTORS
            RELATED TO THE MARKETS IN GENERAL OR TO THE IMPLEMENTATION OF ANY
            SPECIFIC TRADING PROGRAM WHICH CANNOT BE FULLY ACCOUNTED FOR IN THE
            PREPARATION OF HYPOTHETICAL PERFORMANCE RESULTS AND ALL OF WHICH CAN
            ADVERSELY AFFECT ACTUAL TRADING RESULTS.
          </p>
          <p>
            Trading is never without risk and you are urged to carefully read
            and consider the following before utilizing any or all of our
            services: (a) No aspect of the Site is intended to provide, or
            should be construed as providing, any investment, tax or other
            financial related advice of any kind. You should not consider any
            content on the Site to be a substitute for professional financial
            advice. While individual participants may offer investment advice or
            opinions and/or effect a transaction which may be subsequently
            copied by another trader, such advice, opinions, or trades amount to
            nothing more than exchanges between persons who may be anonymous or
            unidentifiable or simply the execution of a trade by such traders.
            Be Brokers does not provide investment advice directly, indirectly,
            implicitly, or in any manner whatsoever by making such information
            and/or features available to you. You should use any information
            gathered from here and/or utilize the features only as a starting
            point for your own independent research. (b) The Site, Services, and
            features are provided by Be Brokers solely for informational
            purposes. Be Brokers and/or any on its behalf, including its
            affiliates and their employees and agents are not investment or
            financial advisers. ANY INVESTMENT DECISIONS YOU MAY MAKE IN
            RELIANCE ON INFORMATION WHICH IS AVAILABLE ON OUR WEBSITE, ARE AT
            YOUR OWN RISK AND Be Brokers, AND ITS PARTNERS, AFFILIATES,
            EMPLOYEES AND AGENTS WILL NOT BE LIABLE FOR ANY LOSSES THAT YOU MAY
            SUSTAIN. YOU ARE SOLELY AND EXCLUSIVELY RESPONSIBLE FOR DETERMINING
            WHETHER ANY INVESTMENT, OR STRATEGY, OR ANY OTHER PRODUCT OR SERVICE
            IS APPROPRIATE OR SUITABLE FOR YOU BASED ON YOUR INVESTMENT
            OBJECTIVES AND PERSONAL AND FINANCIAL SITUATION.
          </p>
          <p>
            Any comments/opinions or market advice found on the website are not
            necessarily the opinions of Be Brokers.
          </p>
        </article>
      </div>
    </>
  )
}
